export const FlipSlides1 = () => {
  return (
    <svg height={"auto"} id="Capa_1" viewBox="0 0 469 887" width={"100%"} xmlns="http://www.w3.org/2000/svg">
    <defs />
    <rect
      height="10241"
      style={{ fill: 'none', stroke: 'red', strokeWidth: 6 }}
      width="3265"
      x="-517"
      y="-2407"
    />
    <g>
      <g>
        <rect
          height="697.66"
          style={{ fill: '#e5e5e5', rx: 33.8, ry: 33.8 } as React.CSSProperties}
          width="341.06"
          x="64"
          y="95.01"
        />
        <path
          d="M371.27,797.17H97.8c-21.12,0-38.3-17.18-38.3-38.3V128.81c0-21.12,17.18-38.3,38.3-38.3h273.47c21.12,0,38.3,17.18,38.3,38.3v630.06c0,21.12-17.18,38.3-38.3,38.3ZM97.8,99.52c-16.15,0-29.3,13.14-29.3,29.3v630.06c0,16.15,13.14,29.3,29.3,29.3h273.47c16.15,0,29.3-13.14,29.3-29.3V128.81c0-16.15-13.14-29.3-29.3-29.3H97.8Z"
          style={{ fill: '#ccc', stroke: '#ccc', strokeMiterlimit: 10 }}
        />
      </g>
      <g>
        <rect
          height="31.23"
          style={{ fill: '#fff', rx: 7, ry: 7 } as React.CSSProperties}
          width="97.24"
          x="185.91"
          y="117.18"
        />
        <circle
          cx="269.8"
          cy="132.79"
          r="4.13"
          style={{ fill: '#e5e5e5' }}
        />
      </g>
    </g>
    <g>
      <rect
        height="506.31"
        style={{ fill: 'gray' }}
        width="279"
        x="95"
        y="190.91"
      />
      <rect
        height="506.31"
        style={{ fill: '#4d4d4d' }}
        width="139.68"
        x="234.32"
        y="190.91"
      />
      <circle
        cx="234.68"
        cy="431.04"
        r="31.53"
        style={{ fill: '#fff' }}
      />
      <polygon
        points="241.74 451.65 222.47 432.38 241.86 412.99 244.97 416.1 228.69 432.38 244.85 448.54 241.74 451.65"
        style={{ fill: 'gray' }}
      />
    </g>
  </svg>
  )
}
